module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-case"
  }, [_c('img', {
    staticClass: "top-img",
    attrs: {
      "src": require("assets/case/04/img1.png")
    }
  }), _vm._m(0), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": require("assets/goTop.png")
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "case-num"
  }, [_vm._v("Vol.04")]), _c('div', {
    staticClass: "case-title"
  }, [_vm._v("上海市区一套房，郊外一栋度假屋，生活这样真挺好！")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("经济发展水平越高，越多的中产阶级会渴望返璞归真，栖居田园。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("平时工作、学习在市区，周末住郊外感受辽阔乡野，懂窝客户Josie就是这样。她把上海崇明老宅改造翻新，成了一家人周末小聚度假的胜地。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("认识屋主")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("Josie，美丽的二娃宝妈。早年从事画廊工作，对美和艺术有独到理解与认知，喜欢研究服饰、家居搭配，游历世界各地，擅于发现美，更把美带到生活的点滴里。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("房子的基本信息")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("坐标：上海崇明 ")]), _vm._v(" "), _c('span', [_vm._v("户型：三层楼别墅")]), _vm._v(" "), _c('span', [_vm._v("装修风格：现代轻奢")])]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/04/img2.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("崇明自住宅翻新，颠覆传统“乡村风”")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("Josie先生是上海崇明人，这栋房子是崇明父母家的自住宅。老人家年纪大了，希望能改善下居住环境，Josie也希望在乡下给孩子们留更多玩耍的空间。于是一家人决定对老宅进行翻新。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("崇明有很多别墅，装修都比较传统，简单的白墙和装饰，在Josie看来是对空间的一种浪费。所以在装修自己家的时候，就着意颠覆传统“乡村风”。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/04/img3.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("上下三层楼，一楼空间主要是客厅和老人卧室，二楼是Josie一家的生活空间，三楼是健身房和孩子们的娱乐室。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("房子的硬装整体以轻奢风为主，墙面和天花都用了很多石膏板、线，更不乏大理石、金线勾勒，凸显轻奢时尚的气质。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("Josie对色彩的搭配有很多自己的理解，比如一楼整体以米色、灰色为主，简约耐看。相对沉稳的配色也能迎合老人的审美偏好。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/04/img1.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("二楼是客厅、主卧和2个儿童房。客厅墙面没有跟随近几年非常流行的复古绿，而是选用淡绿色，让空间显得更宽敞，也很跳跃有活力。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("三次装修，不断迭代的审美")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("家具的选择迎合硬装色彩和整体轻奢的氛围。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("除了定制柜体之外，基本全数购自懂窝，除了一楼客厅的茶几略显小了以外，Josie对自己的搭配甚是满意。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/04/img5.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("毕竟，这是经历过三次装修淬炼出的审美。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("早年第一次装修，是自己的婚房，那时候非常喜欢北欧某品牌的家具，但用久了会觉得品质稍差一些。第二次装修学区房，买了一堆黑胡桃木色的家具，但学区房空间太小，时间长了又会觉得压抑。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("崇明的别墅，比前面两套房子都要大很多，Josie的审美，也开始跃升到对品质、简约风格的追求。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/04/img6.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("她想起初到先生家，看到陈旧过时家具的那种感受，觉得自己再怎样，也要为孩子们打造一个10年20年都仍然耐看的家居环境。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("“简约耐看的家具，同时兼具品质感，时间久了也不会觉得过时。”")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("懂窝的家具，为空间注入灵魂")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝的产品与Josie的审美不谋而合。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("一楼客厅的弗雷德里克沙发，线条简约利落，米白色优雅耐看。意大利头层牛皮，高贵的品质感与绰约的空间气质非常吻合。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/04/img7.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("一盏艾尔弗雷德地灯，搭配在沙发边，轻巧精致，幽静的夜晚，像一轮圆月点缀角落。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("坎普顿边几可以置物收纳，把零碎物件“藏”起来，是Josie所秉承的家居美学理念：把杂物收起来，外观尽可能赏心悦目，随着时间推移，目之所及的地方还可以摆上更多喜欢的物件。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/04/img8.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("主卧带阳台，马利克斯双人床与床头柜，进口楸木实木气质温暖。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/04/img9.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("书房也是Josie使用频率很高的地方，胡桃木色莱拉书桌与欧文台灯在丝绒窗帘映衬下，营造出一处静谧的读书角。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/04/img10.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("三楼是一家人的活动空间兼衣帽间，练瑜伽、跑步，小孩玩耍，都有足够的空间。福斯抽象画摆在一角，运动完了可以坐下赏画静思，在这样一个空间里放空身心，是Josie在国外游历所习得的生活方式。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("在这栋度假屋里，荡涤工作日在城市里沾染的喧嚣，吐纳一方悠然与静谧，这样的家，大概也是很多人的梦想吧。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/04/img11.png")
    }
  }), _c('div', {
    staticClass: "cont-title1"
  }, [_vm._v(" Q&A")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：整个装修花了多少预算？")]), _vm._v("A：硬装是找朋友做的，其实没花太多，大概30万左右，家具软装这些50多万，加上老房拆改工程、电器等，100万左右吧。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：为什么想花这么多预算或精力来装修这套房子？")]), _vm._v("A：平时工作、上学住在上海市区，生活其实挺累的，孩子们周末也没太多地方去玩，加上长辈们也想改善下居住环境，就把房子彻底翻新改造一下，这样大家都会住得非常舒服。一个小时的车程也不会太远，一家人也可以经常团聚。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：你对装修或色彩搭配这块有什么个人偏好吗？")]), _vm._v("A：其实我是一个颜值控，喜欢有设计感、美的东西，然后对这些也比较挑剔。从家具搭配风格看，我比较偏向简约耐看的，因为家具要用10年、20年，它应该是品质上经久耐用的，设计上又不易过时的。同时色彩可以亮一些，这样会让氛围更加跳跃，也比较温馨。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：为什么选购懂窝的产品？")]), _vm._v("A：我家除了一些柜体，基本上的成品家具都在懂窝买的。还是比较符合我个人审美吧，包括品质细节这些都不错，比如床头柜里面还有一层绒布，很精致。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5011e6ee"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/case4.vue
// module id = 444
// module chunks = 0